import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't scroll to `#hash` targets on navigation the way a real
 * page load does — `<Link to="/#workflows">` from another route (or even the
 * same route) just changes the URL and leaves the scroll position alone. This
 * restores that behavior so the landing page's Workflows/Security/Teams nav
 * links land on the right section from anywhere in the app.
 */
export function useScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = hash.slice(1);

    const scroll = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    };

    if (scroll()) return undefined;
    // Cross-page navigation (e.g. /pricing -> /#workflows): the target
    // section isn't in the DOM yet on the first render of the new route —
    // retry briefly until it mounts.
    const timeout = setTimeout(scroll, 100);
    return () => clearTimeout(timeout);
  }, [hash, pathname]);
}
